import { render, staticRenderFns } from "./ActionsCreateNewWebsiteCss.vue?vue&type=template&id=672e26cb&lang=pug&"
import script from "./ActionsCreateNewWebsiteCss.vue?vue&type=script&lang=js&"
export * from "./ActionsCreateNewWebsiteCss.vue?vue&type=script&lang=js&"
import style0 from "./ActionsCreateNewWebsiteCss.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports